module.exports = "file3";


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/error-handling/folder/file3.js
 ** module id = 3
 ** module chunks = 0
 **/